/** Shared colors for reporting/dashboard – ตรวจไขว้ vs ส่งเอง */
export const OWN_SUBMISSION_COLOR = '#3b82f6';
export const CROSS_AUDIT_COLOR = '#f59e0b';
